<template>
    <div id="slide-show" :class="[showGallery ? 'withThumbnails' : '']">
        <div id="slide-show-scroller-div">
            <div class="primarycarslide" :class="[slideIndex > -1 ? 'hidden' : '']"> 
                <div id="imageLoadingSpinner" :class="[imageLoading ? 'appear' : '']"></div>
                <div id="primaryImageSlide">
                    <img :src="primaryImage"  @load="mainImageLoaded" @error="imageUrlAlt" class="primaryImage"/>
                    <div v-if="lifetimeWarranty" class="carcutterImageFooter">
                        <div class="smallMsg">
                            Undergoing 172-Point Inspection For Your 
                        </div>
                        <div class="attentionMsg">
                            <b>FREE LIFETIME WARRANTY</b>
                        </div>
                    </div>
                </div>
            </div>
            <div v-for="(car_image, index) in galleryImages" :key="index" class="carslide" :class="[index != slideIndex ? 'hidden' : '']">
                <img :id="index" :src="car_image.URL" @error="removeBroken">
            </div>
            <div class="arrow left" v-if="showGallery" @click="right">
                &lt;
            </div>
            <div class="arrow right" v-if="showGallery" @click="left">
                &gt;
            </div>
        </div>
        <div id="thumbnail-scroll-div" v-if="showGallery">
            <div v-for="(car_image, index) in galleryImages" :key="index" class="galleryThumbnails">
                <img :id="index" :src="car_image.URL" class="selectableThumbnail" @error="hideImage" @click="jumpToImage">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                slideIndex: -1,
                imageLoading: true
            }
        },
        computed: {
            vehicle() {
                return this.$store.getters.vehicleGallerySelected;
            },
            galleryImages() {
                return this.$store.getters.getOpenGalleryImages;
            },
            isBlueBlanket() {
                return (this.vehicle.cached_thumbnail && this.vehicle.cached_thumbnail.includes('BlueBlanket'));
            },
            primaryImage() {
                return this.isBlueBlanket ? this.vehicle.cached_thumbnail.replace("_400h", "") : ((this.vehicle.cached_primary_image) ? this.vehicle.cached_primary_image : (this.vehicle.PrimaryImage ? this.vehicle.PrimaryImage : "/pictures_coming_soon.png"));
            },
            isLoggedIn() {
                return this.$store.getters.isLoggedIn;
            },
            showGallery() {
                return this.isLoggedIn && !this.isBlueBlanket && this.galleryImages.length > 0;
            },
            lifetimeWarranty() {
                return this.vehicle.Miles < 99000 && this.vehicle.Year > ((new Date).getFullYear() - 19);
            }
        },
        methods: {
            right() {
                this.$gtag.event('next', {'event_category': 'vehicle_gallery'});
                
                if(this.slideIndex == -1) {
                    this.slideIndex = this.galleryImages.length;
                }

                this.slideIndex--;
            },
            left() {
                this.slideIndex++;

                this.$gtag.event('previous', {'event_category': 'vehicle_gallery'});
                
                if(this.slideIndex == this.galleryImages.length) {
                    this.slideIndex = -1;
                }
            },
			imageUrlAlt(event) {
                if(this.vehicle.cached_thumbnail && this.vehicle.cached_thumbnail.includes('BlueBlanket')) {
                    event.target.src = this.vehicle.cached_thumbnail.replace("_400h", "");
                }
                else {
                    event.target.src = "/pictures_coming_soon.png"
                }
            },
            hideImage(event) {
                event.target.style.display = "none";
            },
            jumpToImage(event) {
                let jumpIndex = event.target.id;
                this.$gtag.event('jumpTo', {'event_category': 'vehicle_gallery'});

                this.slideIndex = jumpIndex;
            },
            removeBroken(event) {
                let toRemove = event.target.id;
                this.$store.commit('removeBrokenImageFromGallery', toRemove);
            },
            mainImageLoaded() {
                this.imageLoading = false;
            }
        }
    }
</script>

<style>
    #slide-show {
        height: calc((((40 / 4) * 3) * var(--vw)) + (4 * var(--vw)));
        width: calc(44 * var(--vw));
        background-color: white;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }

    #primaryImageSlide {
        background: radial-gradient(250% 100% at bottom, #333, #333 10%, #BEBEBE 56%, transparent 44%), 
                    linear-gradient(to top, #BEBEBE 50%, #eee 56%, #DEDEDE 96%); 
        height: inherit;
        width: inherit;
        position: relative;
    }

    .carCutterImgLogo {
        max-height: 18%; 
        /*padding: 2%;*/
    }

    .primaryImage {
        max-height: 98%;
        padding: 1%;
    }

    /*.noWarranty .primaryImage {
        max-height: 78%;
    }*/

    .carcutterImageFooter {
        width: 98%;
        height: 10%;
        padding: 1%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        font-size: 1.5em;
        color: white;
        background: var(--mccluskeyBlue);
        position: absolute;
        bottom: 0px;
    }

    .smallMsg {
        font-size: .86em;
    }

    .attentionMsg {
        letter-spacing: .2rem;
    }

    .inmobile .carcutterImageFooter {
        font-size: calc(1.8 * var(--vh));
    }

    #slide-show.withThumbnails {
        width: calc(50 * var(--vw));
    }

    #slide-show-scroller-div {
        width: calc(40 * var(--vw));
        height: calc((40 / 4) * 3 * var(--vw));
        position: relative;
    }

    #thumbnail-scroll-div {
        width: calc(6 * var(--vw));
        height: calc((40 / 4) * 3 * var(--vw));
        display: flex;
        flex-direction: column;
        overflow-y: scroll;
        overflow-x: hidden;
    }

    .inmobile.tabletstyle #thumbnail-scroll-div {
        height: calc(8 * var(--vw));
        width: calc(((60 / 3) * 4) * var(--vh));
        flex-direction: row;
        overflow-x: scroll;
        overflow-y: hidden;
    }

    .inmobile #thumbnail-scroll-div { 
        height: calc(20 * var(--vw));
        width: inherit;
        flex-direction: row;
        overflow-x: scroll;
        overflow-y: hidden;
    }

    .galleryThumbnails {
        width: inherit;
    }

    .inmobile .galleryThumbnails {
        height: inherit;
    }

    .carslide,
    .primarycarslide {
        height: inherit;
        width: inherit;
    }
    
    .carslide img {
        height: inherit;
        width: inherit;
        object-fit: cover;
    }
    
    .hidden {
        display:none;
    }
    
    .arrow {
        position: absolute;
        top: calc(((((40 / 4) * 3) / 2) * var(--vw)) - 35px);
        color: white;
        opacity: 0.35;
        font-size: 70px;
    }

    .inmobile .arrow {
        top: calc(((((100 / 4) * 3) / 2) * var(--vw)) - 47.5px);
    }

    .inmobile.tabletstyle .landscape .arrow {
        top: calc(((((62.5 / 4) * 3) / 2) * var(--vw)) - 35px);
    }

    .arrow.right {
        right: calc(.5 * var(--vw));
    }

    .arrow.left {
        left: calc(.5 * var(--vw));
    }

    .arrow:hover {
        opacity: .8;
        color: var(--mccluskeyGold); /*#AF873F;*/
        cursor: pointer;
    }

    .inmobile #slide-show {
        display: flex;
        align-items: center;
        justify-content: center;
        width: calc(100 * var(--vw));
        height: calc((100 / 4) * 3 * var(--vw));
        flex-direction: column;
    }

    .inmobile #slide-show.withThumbnails {
        height: calc(((100 / 4) * 3 * var(--vw)) + (20 * var(--vw)));
    }

    .inmobile.tabletstyle .landscape #slide-show {
        width: clac(100 * var(--vw));
        height: calc(65 * var(--vh));
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .inmobile.tabletstyle .landscape #slide-show.withThumbnails {
        height: calc((65 * var(--vh)) + (8 * var(--vw)));
    }

    .inmobile #slide-show-scroller-div {
        width: inherit;
        height: calc((100 / 4) * 3 * var(--vw));
    }

    .inmobile.tabletstyle .landscape #slide-show-scroller-div {
        height: calc(60 * var(--vh));
        width: calc(((60 / 3) * 4) * var(--vh));
    }

    #vehiclePrimaryImage > img {
        width: inherit;
        height: inherit;
        object-fit: cover;
    }

    .selectableThumbnail {
        width: calc((6 * var(--vw)) - (.4 * var(--vw)));
    }

    .inmobile .selectableThumbnail {
        width: calc((20 * var(--vw)) - (.4 * var(--vw)));
    }

    .inmobile.tabletstyle .selectableThumbnail {
        width: calc((8 * var(--vw)) - (.4 * var(--vw)));
    }

    #imageLoadingSpinner {
        position: absolute;
        top: calc(50% - 5.375vw);
        left: calc(50% - 5.375vw);
        z-index: -1;
        width: 10vw;
        height: 10vw; 
        border: .75vw solid rgb(172,179,183);
        border-radius: 50%;
        border-top: .75vw solid #207BD3;
        -webkit-animation: spin 3s linear infinite;
        animation: spin 3s linear infinite;
        opacity: 0;
        -webkit-transition: opacity 1s;
        -moz-transition: opacity 1s;     
        transition: opacity 1s;
    }

    #imageLoadingSpinner.appear {
        opacity: 1;
        z-index: 121;
    }

    #imageLoadingSpinner.appear + #primaryImageSlide {
        opacity: .4;
    }

    .inmobile #imageLoadingSpinner {
        top: calc(50% - 11vw);
        left: calc(50% - 11vw);
        width: 20vw;
        height: 20vw; 
        border: 2vw solid rgb(172,179,183);
        border-top: 2vw solid #207BD3;
    }
</style>